const isPositiveId = (id) => {
  const num = Number(id);
  return Number.isFinite(num) && num > 0;
};

const isFilledText = (value) => value !== null && value !== undefined && String(value).trim() !== '';

// Поля, без которых автомобиль нельзя добавить в сделку (нужны банкам/договорам).
export const CAR_REQUIRED_FIELDS = [
  {
    label: 'Комплектация',
    isMissing: (car) => !isPositiveId(car?.complectationId) && !isPositiveId(car?.complectation?.id),
  },
  {
    label: 'Объем двигателя',
    isMissing: (car) => !isFilledText(car?.engine_volume),
  },
  {
    label: 'Тип двигателя',
    // Тип двигателя берется из комплектации, отдельно на авто не хранится.
    isMissing: (car) => !isFilledText(car?.complectation?.engine?.title) && !isPositiveId(car?.complectation?.engine?.id),
  },
  {
    label: 'Тип коробки передач',
    isMissing: (car) =>
      !isPositiveId(car?.transmissionId) && !isPositiveId(car?.transmission?.id) && !isFilledText(car?.transmission),
  },
];

const getCarMissingFields = (car) => CAR_REQUIRED_FIELDS.filter((field) => field.isMissing(car)).map((field) => field.label);

export default getCarMissingFields;
